import { render, staticRenderFns } from "./ApplicantProjectDetail.vue?vue&type=template&id=067c2dc2&"
import script from "./ApplicantProjectDetail.vue?vue&type=script&lang=js&"
export * from "./ApplicantProjectDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports